import React from 'react';
import AccountSelection from './AccountSelection';

const AccountSelectionModal = ({ isOpen, onClose, broker, onAccountSelected }) => {
  if (!isOpen) {
    return null;
  }

  const handleAccountSelected = (accountId, accountData) => {
    if (onAccountSelected) {
      onAccountSelected(accountId, accountData);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75"
          onClick={onClose}
        />

        {/* Modal container */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

        <div className="inline-block align-bottom bg-gray-900 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6 border border-gray-700">
          <AccountSelection
            broker={broker}
            onAccountSelected={handleAccountSelected}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountSelectionModal;